<template>
	<b-container fluid>
		<b-row>
			<b-col sm="12">
				<card>
					<template v-slot:headerTitle>
						<h4 class="card-title">Edit Slider Group</h4>
					</template>

					<template v-slot:body>
						<!---- Add group form starts ---->

						<b-form @submit.prevent="editGroup">
							<b-row>
								<b-col md="6" xl="6" class="form-group">
									<label class="control-label">Title <span class="required">*</span></label>
									<b-form-input v-model="group.group_name" v-bind:class="{ 'is-invalid': Boolean(errors.title) }" minlength="3" maxlength="100" @keypress="alphaSpacesOnly"></b-form-input>
									<div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
							
								<b-col md="6">
									<label class="control-label">Location <span class="required">*</span></label>
									<GmapAutocomplete @keypress.enter="$event.preventDefault()" @place_changed="setPlace" class="form-control" :value="group.location" v-bind:class="{ 'is-invalid': Boolean(errors.location) }" @change="setLocation"/>
									<div v-for="(val, index) in errors.location" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
							</b-row>
							<b-row>
								
								<b-col md="6" xl="6" class="form-group">
									<label class="control-label">Latitude <span class="required">*</span></label>
									<b-form-input v-model="group.latitude" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"></b-form-input>
									<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>

								<b-col md="6" xl="6" class="form-group">
									<label class="control-label">Longitude <span class="required">*</span></label>
									<b-form-input v-model="group.longitude" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"></b-form-input>
									<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>

								<b-col md="12">
									<b-button type="submit" class="mr-3" variant="primary">Update</b-button>
									<router-link :to="{ name: 'sliders.groups' }" class="btn btn-light">Cancel</router-link>
								</b-col>
							</b-row>
						</b-form>

						<!----Add group form ends ----->
					</template>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
	export default {
		name: "EditGroup",
		data() {
			
			return {
				group: {
					id: null,
					group_name: "",
					location: "",
					latitude: null,
					longitude: null,
				},

				token: "",
				errors: {},
			};
		},
		mounted() {
			
		},

		created() {
			this.fetchGroup();
		},

		methods: {
			decimalsOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode < 48 || keyCode > 57) {
		        event.preventDefault();
		      }
		    },
		   alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		   },
		   fetchGroup() {
				this.getToken();
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/groups/show?group_id=" + this.$route.params.id, config)
					.then((response) => {
						this.group = response.data.data;
					})
					.catch((err) => console.log(err));
			},

    		setPlace(place) {
    			this.current_place = place;
    			if(this.current_place) {
    				const marker = {
	    				lat: this.current_place.geometry.location.lat(),
	    				lng: this.current_place.geometry.location.lng(),
	    			};
	    			
	    			this.group.location = place.formatted_address;
	    			this.group.latitude = marker.lat;
	    			this.group.longitude = marker.lng;
    			}
    		},

    		setLocation(e) {
			   	this.group.location = e.target.value;
			},
		   
			getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

			editGroup() {

				this.getToken();
				let formData = new FormData();
				formData.append("title", this.group.group_name);
				formData.append("location", this.group.location);
				formData.append("latitude", this.group.latitude);
				formData.append("longitude", this.group.longitude);
				formData.append("group_id", this.group.id);
				
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				url = "/api/admin/groups/edit";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.$router.push({ name: "sliders.groups.view" });
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},

			clearForm() {
				this.group.title = "";
				this.group.location = "";				
				this.group.latitude = null;
				this.group.longitude = null;
				this.errors = {};
				
			},
		},
	};
</script>
